import { render } from "./TransactionsHistory.vue?vue&type=template&id=20c6e5f1&ts=true"
import script from "./TransactionsHistory.vue?vue&type=script&lang=ts"
export * from "./TransactionsHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__